// cytoscapeStyles.js

export const initialNodeStyle = {
  "background-color": "white",
  label: "data(label)",
  "text-valign": "center",
  "text-halign": "center",
  width: "20px",
  height: "20px",
  color: "black",
  "border-width": 1,
  "border-color": "black",
  "font-size": "10px",
};

export const initialDirectedEdgeStyle = {
  "curve-style": "straight",
  "control-point-step-size": 30,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "black",
  "line-color": "black",
  width: 2,
  "text-background-color": "white",
  "text-background-opacity": 1,
};

export const initialDirectedWeightedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "black",
  width: 2,
  label: "data(weight)",
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "black",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": (ele) => {
    const sourcePos = ele.source().position();
    const targetPos = ele.target().position();
    return sourcePos.x > targetPos.x ? -10 : 10;
  },
  "text-halign": "center", // Align text to the center horizontally
  "text-valign": "top",
};

export const visitedDirectedWeightedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "green",
  width: 2,
  label: "data(weight)",
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "green",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": -10,
};

export const visitingDirectedWeightedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "grey",
  width: 2,
  label: "data(weight)",
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "grey",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": -10,
};

export const initialUndirectedWeightedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "black",
  width: 2,
  label: "data(weight)",
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "none",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": (ele) => {
    // Customize text margin based on the edge direction
    const sourcePos = ele.source().position();
    const targetPos = ele.target().position();
    return sourcePos.x > targetPos.x ? -10 : 10;
  },
  "text-halign": "center", // Align text to the center horizontally
  "text-valign": "top",
};

export const visitingUndirectedWeightedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "grey",
  width: 2,
  label: "data(weight)",
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "none",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": -10,
};

export const visitedUndirectedWeightedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "green",
  width: 2,
  label: "data(weight)",
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "none",
  "text-rotation": "autorotate", // Automatically rotate the label
  "text-margin-y": -10, // Adjust the vertical margin to position the label above the arrow
  "text-margin-x": -10,
};

export const initialUndirectedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "black",
  width: 2,
  label: "data(label)",
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "none",
};

export const visitedNodeStyle = {
  "background-color": "black",
  color: "white",
};

export const visitedDirectedEdgeStyle = {
  "curve-style": "straight",
  "control-point-step-size": 30,
  "target-arrow-shape": "triangle",
  "target-arrow-color": "green",
  "line-color": "green",
  width: 2,
  "text-background-color": "white",
  "text-background-opacity": 1,
};

export const visitedUndirectedEdgeStyle = {
  "curve-style": "straight", // Use unbundled-bezier for better edge separation
  "control-point-step-size": 30,
  "line-color": "green",
  width: 2,
  "text-background-color": "white",
  "text-background-opacity": 1,
  "target-arrow-shape": "none",
};

export const visitingNodeStyle = {
  "background-color": "grey",
};
